import { FiUpload } from "react-icons/fi";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";
import { EXCEL_FILE_TYPE } from "../../../constants";
import { Icon, UploadButton } from "../../../components/base";
import ExcelIcon from "../../../assets/images/icons/excel.svg";

const useStyles = makeStyles((theme) => ({
  uploadedFileContaner: {
    position: "relative",
    margin: "auto",
    width: "fit-content",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    "&:hover": {
      border: `1px solid ${COLORS.darks[0][25]}`,
      "& > svg": {
        display: "block",
      },
    },
    borderRadius: 10,
    "& > svg": {
      display: "none",
      position: "absolute",
      top: -8,
      right: -10,
    },
  },
}));

export const UploadData = ({ selectedFile, setSelectedFile }) => {
  const classes = useStyles();

  return (
    <Box
      borderRadius={8}
      bgcolor={COLORS.darks[0][10]}
      height="100%"
      minHeight={300}
      pt={10}
      boxSizing="border-box"
    >
      {selectedFile ? (
        <Grid
          className={classes.uploadedFileContaner}
          container
          justifyContent="center"
          alignItems="center"
        >
          <Icon src={ExcelIcon} />
          <Typography variant="h4">{selectedFile.name}</Typography>
          <HighlightOffIcon onClick={() => setSelectedFile()} />
        </Grid>
      ) : (
        <>
          <Box margin="auto" width="fit-content" pb={5} position="relative">
            <FiUpload style={{ color: COLORS.purple, fontSize: 60 }} />
          </Box>
          <Grid container alignItems="center" justifyContent="center" style={{ columnGap: 4 }}>
            <Typography variant="h4">Please</Typography>
            <UploadButton
              textStyle={{ fontSize: 18, fontWeight: 400, lineHeight: "24px" }}
              text="upload the building data excel"
              onlyText={true}
              accept={EXCEL_FILE_TYPE}
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
            <Typography variant="h4">once you have filled it out</Typography>
          </Grid>
        </>
      )}
    </Box>
  );
};
